import { getObjectUtil } from 'packages/src'
import { getPathReduxUtil } from '../get-path'

function getInstanceReduxUtil (state, instance) {
  if (!instance) {
    return
  }
  return getObjectUtil(state, getPathReduxUtil(instance))
}

export default getInstanceReduxUtil
